import type { Dispatch, SetStateAction } from 'react';
import type { KlarnaPaymentsProps } from '@adyen/adyen-web/dist/types/components/Klarna/types';
import type { FetchResult } from '@apollo/client';
import type { PlaceOrderMutation } from '../../../graphqlDocument/order/placeOrder.generated';
import type { CartAddress } from '../useAdyenConfig';

// Adyen docs - web components - klarna
// https://docs.adyen.com/payment-methods/klarna/web-component/

export interface CreateKlarnaConfigProps {
  setIsPaymentBtnDisabled: Dispatch<SetStateAction<boolean>>;
  setPaymentInProgress: Dispatch<SetStateAction<boolean>>;
  setPaymentError: Dispatch<SetStateAction<boolean>>;
  placeOrderMutation: () => Promise<FetchResult<PlaceOrderMutation, Record<string, unknown>, Record<string, unknown>>>;
  resolveData: (data: CartAddress) => Promise<CartAddress>;
}

export const createKlarnaConfig = ({
  setIsPaymentBtnDisabled,
  setPaymentInProgress,
  setPaymentError,
  placeOrderMutation,
  resolveData,
}: CreateKlarnaConfigProps): Partial<KlarnaPaymentsProps> => ({
  // TODO: sdkData, paymentData, and paymentMethodType are required by default for Klarna — confirm if they're necessary
  showPayButton: false,
  useKlarnaWidget: false,
  beforeSubmit: async (data, _, actions) => {
    setIsPaymentBtnDisabled(true);
    setPaymentInProgress(true);

    const result = await placeOrderMutation();

    if (result.data?.placeOrder.accepted) {
      actions.resolve(await resolveData(data));
    } else {
      actions.reject();

      setPaymentError(true);
      setIsPaymentBtnDisabled(false);
      setPaymentInProgress(false);
    }
  },
});
